import React from 'react';

import { Button, Text, cn } from '@eluve/components';

import type { FhirPageControls } from './useFhirData';

/**
 * Explicit paging affordance for Connection-backed lists: renders nothing
 * while every row is loaded, otherwise a "Load more" button with loaded/total
 * progress. Pass any FhirConnectionState — it structurally satisfies
 * FhirPageControls.
 */
export function LoadMoreRow({
  paging,
  noun = 'items',
  className,
}: {
  paging: FhirPageControls;
  /** Plural noun for the progress copy, e.g. "locations". */
  noun?: string;
  className?: string;
}) {
  if (!paging.hasMore) return null;
  return (
    <div
      className={cn('flex items-center justify-center gap-3 py-3', className)}
    >
      <Button
        variant="outline"
        size="sm"
        disabled={paging.loadingMore}
        onClick={paging.loadMore}
      >
        {paging.loadingMore ? 'Loading…' : 'Load more'}
      </Button>
      <Text size="xs" color="tertiary" weight="regular">
        {paging.loaded.toLocaleString()} of{' '}
        {(paging.count ?? paging.loaded).toLocaleString()} {noun}
      </Text>
    </div>
  );
}
